import { createOrderNumberColumn } from './order-number';
import { originWarehouseColumn } from './origin-warehouse';
import { destinationWarehouseColumn } from './destination-warehouse';
import { transferOrderStatusColumn } from './transfer-order-status';
import { orderDateColumn } from './order-date';
import { expectedDeliveryDateColumn } from './expected-delivery-date';
import { receiveStockColumn } from './receive-stock';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';

export const baseColumns = {
  [transferOrderGridProperties.orderNumber]: createOrderNumberColumn(),
  [transferOrderGridProperties.originWarehouseName]: originWarehouseColumn,
  [transferOrderGridProperties.destinationWarehouseName]: destinationWarehouseColumn,
  [transferOrderGridProperties.status]: transferOrderStatusColumn,
  [transferOrderGridProperties.orderDate]: orderDateColumn,
  [transferOrderGridProperties.expectedDeliveryDate]: expectedDeliveryDateColumn,
  [transferOrderGridProperties.receiveStock]: receiveStockColumn,
};
